import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

const RadioButton = ({
  value,
  id,
  onChange,
  name,
  label,
  defaultChecked,
  checked,
  hidden,
  payments,
}) => (
  <div className="radio-button" onClick={onChange} aria-hidden hidden={hidden}>
    <input
      type="radio"
      value={value}
      id={id}
      onChange={onChange}
      name={name}
      defaultChecked={defaultChecked}
      checked={checked}
    />
    <label htmlFor={id}>
      {label}
      {payments ? (
        <p className="description">
          If you want this payment option, please{" "}
          <a className="link" href="mailto:support@datafarming.com.au">
            contact us
          </a>
          .
        </p>
      ) : null}
    </label>

    <div className="check" id={id}>
      <div className="inside" id={id} />
    </div>
  </div>
);

RadioButton.defaultProps = {
  payments: "",
};

RadioButton.propTypes = {
  value: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultChecked: PropTypes.string.isRequired,
  checked: PropTypes.string.isRequired,
  hidden: PropTypes.string.isRequired,
  payments: PropTypes.bool,
};

export default RadioButton;
